import { createElement } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/field/Button';
import Card from 'components/global/Card';
import Typography from 'components/global/Typography';

import { faEllipsis } from '@fortawesome/pro-solid-svg-icons';

import { FilterType } from '../DynamicListFilterUtils';
import { DynamicListComponentMap } from '../DynamicListTable';
import * as S from './DynamicListMapView.styled';

const InfoWindow = ({ columns, hoveredMarker, onContextMenu }) => {
	const { t } = useTranslation();
	return (
		<Card rounded border={false} style={{ maxWidth: '35rem', padding: '2rem 3rem 1rem 2rem' }}>
			{columns?.map((column, index) => {
				const { accessor, renderCell } = column;
				if (!hoveredMarker) return null;
				if (!hoveredMarker[accessor]) return null;

				const value = hoveredMarker[accessor];

				if (renderCell) {
					return (
						<div key={index} style={{ marginBottom: '1rem' }}>
							<Typography fontWeight={500} style={{ minWidth: 'fit-content' }}>
								{t(column.Header)}:&nbsp;
							</Typography>
							{createElement(DynamicListComponentMap[renderCell].component, {
								value,
								data: hoveredMarker,
								column
							})}
						</div>
					);
				}
				const autoTranslation = [
					FilterType.enum,
					FilterType.enumMulti,
					FilterType.selection,
					FilterType.multiSelection
				].includes(column.filterType);
				return (
					<div key={index} style={{ display: 'flex', marginBottom: '1rem' }}>
						<Typography fontWeight={500} style={{ minWidth: 'fit-content' }}>
							{t(column.Header)}:&nbsp;
						</Typography>
						{column.filterType ? (
							<Typography autoTranslation={autoTranslation} fontWeight={500}>
								{value}
							</Typography>
						) : (
							<Typography fontWeight={500}>{value}</Typography>
						)}
					</div>
				);
			})}
			<Button
				variant="transparent"
				icon={faEllipsis}
				iconSize="medium"
				iconButton
				color="var(--black)"
				style={{ flex: '0 0 32px', position: 'absolute', right: '0px', top: '0px' }}
				onClick={onContextMenu}
				css={S.ContextMenuButton}
			/>
		</Card>
	);
};
export default InfoWindow;
